<template>
  <div class="container md-layout">
    <md-progress-bar md-mode="query" class="md-accent" v-if="loading"></md-progress-bar>
    <div class="md-layout-item md-size-100" v-else>
      <md-table md-card>
        <md-table-toolbar>
          <h1 class="md-title">{{ $t("seasons.list.title") }}</h1>
        </md-table-toolbar>

        <md-table-row>
          <md-table-head>{{$t('seasons.list.name')}}</md-table-head>
          <md-table-head>{{$t('seasons.list.edit')}}</md-table-head>
        </md-table-row>

        <md-table-row v-for="season in listSeasons" :key="season.id">
          <md-table-cell>{{season.name}}</md-table-cell>
          <md-table-cell>
            <md-button class="md-info" :to="`/season/${season.id}`">
              {{$t('seasons.list.edit')}}
            </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      listSeasons: state => state.StuffModule.seasons
    })
  },
  data() {
    return {
      loading: true
    }
  },
  mounted() {
    this.$store.dispatch("seasonsGet")
      .then(() => this.loading = false)
  }
};
</script>